// Coordinates for the airports that actually matter to our markets, used to
// auto-pick the nearest airport when an address is chosen. Keys are IATA codes
// matching airports.json so a hit can pre-select the dropdown. The dropdown
// still offers the full airport list for manual override — this is only the set
// we measure distance against, so we never auto-pick a tiny airfield.
export const AIRPORT_COORDS = {
	// Portugal + islands
	FAO: { lat: 37.0144, lng: -7.9659 }, // Faro
	LIS: { lat: 38.7742, lng: -9.1342 }, // Lisbon
	OPO: { lat: 41.2481, lng: -8.6814 }, // Porto
	FNC: { lat: 32.6979, lng: -16.7745 }, // Madeira (Funchal)
	PXO: { lat: 33.0734, lng: -16.35 }, // Porto Santo

	// Spain mainland
	AGP: { lat: 36.6749, lng: -4.4991 }, // Málaga
	ALC: { lat: 38.2822, lng: -0.5582 }, // Alicante
	SVQ: { lat: 37.418, lng: -5.8931 }, // Seville
	GRX: { lat: 37.1887, lng: -3.7773 }, // Granada
	RMU: { lat: 37.803, lng: -1.125 }, // Murcia (Corvera)
	LEI: { lat: 36.8439, lng: -2.3701 }, // Almería
	XRY: { lat: 36.7446, lng: -6.0601 }, // Jerez
	MAD: { lat: 40.4983, lng: -3.5676 }, // Madrid
	BCN: { lat: 41.2974, lng: 2.0833 }, // Barcelona
	VLC: { lat: 39.4893, lng: -0.4816 }, // Valencia
	SCQ: { lat: 42.8963, lng: -8.4151 }, // Santiago de Compostela
	BIO: { lat: 43.3011, lng: -2.9106 }, // Bilbao
	SDR: { lat: 43.4271, lng: -3.82 }, // Santander
	OVD: { lat: 43.5636, lng: -6.0346 }, // Asturias
	GIB: { lat: 36.1514, lng: -5.3497 }, // Gibraltar

	// Spanish islands
	PMI: { lat: 39.5517, lng: 2.7388 }, // Palma (Mallorca)
	IBZ: { lat: 38.8729, lng: 1.3731 }, // Ibiza
	MAH: { lat: 39.8626, lng: 4.2186 }, // Menorca
	TFS: { lat: 28.0445, lng: -16.5725 }, // Tenerife South
	TFN: { lat: 28.4827, lng: -16.3415 }, // Tenerife North
	LPA: { lat: 27.9319, lng: -15.3866 }, // Gran Canaria
	ACE: { lat: 28.9455, lng: -13.6052 }, // Lanzarote
	FUE: { lat: 28.4527, lng: -13.8638 }, // Fuerteventura

	// Wider warm-weather golf destinations
	AYT: { lat: 36.8987, lng: 30.8005 }, // Antalya
	PFO: { lat: 34.718, lng: 32.4857 }, // Paphos
	LCA: { lat: 34.8751, lng: 33.6249 }, // Larnaca
	RAK: { lat: 31.6069, lng: -8.0363 }, // Marrakesh
	AGA: { lat: 30.325, lng: -9.4131 }, // Agadir
	MIR: { lat: 35.758, lng: 10.7547 }, // Monastir
	NBE: { lat: 36.0758, lng: 10.4385 }, // Enfidha
	HRG: { lat: 27.1783, lng: 33.7994 }, // Hurghada
	DXB: { lat: 25.2532, lng: 55.3657 }, // Dubai
	AUH: { lat: 24.433, lng: 54.6511 }, // Abu Dhabi
}

// Haversine great-circle distance in kilometres.
function distanceKm(aLat, aLng, bLat, bLng) {
	const toRad = (degrees) => (degrees * Math.PI) / 180
	const radius = 6371
	const dLat = toRad(bLat - aLat)
	const dLng = toRad(bLng - aLng)
	const lat1 = toRad(aLat)
	const lat2 = toRad(bLat)
	const h = Math.sin(dLat / 2) ** 2 + Math.cos(lat1) * Math.cos(lat2) * Math.sin(dLng / 2) ** 2
	return 2 * radius * Math.asin(Math.sqrt(h))
}

// Nearest known airport IATA code to a lat/lng, or null if we can't resolve it.
export function nearestAirportCode(lat, lng) {
	const numLat = Number(lat)
	const numLng = Number(lng)
	if (Number.isNaN(numLat) || Number.isNaN(numLng)) return null

	let best = null
	let bestDistance = Infinity
	for (const [code, coords] of Object.entries(AIRPORT_COORDS)) {
		const distance = distanceKm(numLat, numLng, coords.lat, coords.lng)
		if (distance < bestDistance) {
			bestDistance = distance
			best = code
		}
	}
	return best
}
